module.exports = __webpack_public_path__ + "static/media/logo.08ac2fa1.png";